import { Lock } from "lucide-react"
import { cn } from "@/lib/utils"

/** A dashboard tile for a metric the spec calls for but the backend does NOT
 *  yet collect the data for. Rendered as a clearly-labeled dashed card so the
 *  layout matches the spec while staying honest — no fake numbers. `need`
 *  explains what instrumentation would unlock it. */
export function PlaceholderCard({
  title,
  need,
  className,
}: {
  title: string
  need: string
  className?: string
}) {
  return (
    <div
      className={cn(
        "rounded-lg border border-dashed bg-muted/20 p-4 flex flex-col",
        className,
      )}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <span className="text-sm font-medium text-muted-foreground">
          {title}
        </span>
        <span className="inline-flex items-center gap-1 rounded-full border border-dashed px-2 py-0.5 text-[10px] uppercase tracking-wide text-muted-foreground shrink-0">
          <Lock className="size-2.5" /> Not yet tracked
        </span>
      </div>
      <div className="flex-1 flex items-center justify-center py-4">
        <p className="text-xs text-muted-foreground/80 text-center max-w-[34ch] leading-relaxed">
          {need}
        </p>
      </div>
    </div>
  )
}
